const numberToThousandsString = (num?: string | number) => {
  if (!num) return;
  let number;
  if (typeof num === 'string') {
    number = parseInt(num);
  } else {
    number = num;
  }
  const thousands = number && Math.floor(number / 1000);
  if (number >= 1000) {
    return thousands + 'K';
  } else {
    return number;
  }
};

const numberFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
});

export { numberFormatter, numberToThousandsString };
